<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <v-text-field
            label="Busca"
            v-model="filter"
            outlined
            dense
            hide-details
            append-icon="eva-search-outline"
            clearable
            background-color="white"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="light-blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click:outside="close"
              >
                Novo facilitador
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="headline">Novo facilitador</span>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row dense>
                    <v-col>
                      <v-text-field
                        outlined
                        dense
                        v-model="facilitator.value"
                        v-uppercase
                        label="Valor"
                        :hide-details="!errors.facilitator"
                        :error-messages="errors.facilitator"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <v-row
        dense
        v-for="facilitator in actionFacilitators"
        :key="facilitator.id"
      >
        <v-col>
          <ConductActionFacilitatorListItem
            :facilitator="facilitator"
            :facilitators="facilitators"
            :facilitatorType="facilitatorType"
            :refreshList="refreshList"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ConductActionFacilitatorListItem from "@/components/config/conduct/action_facilitator/item/index.vue";

export default {
  name: "ConductActionFacilitatorList",
  props: {
    facilitators: Array,
    facilitatorType: String,
    refreshList: Function,
  },
  components: {
    ConductActionFacilitatorListItem,
  },
  data() {
    return {
      errors: {},
      dialog: null,
      facilitator: {},
      filter: "",
    };
  },
  computed: {
    actionFacilitators() {
      let facilitators = this.lodash.filter(this.facilitators, {
        category: this.facilitatorType,
      });

      if (this.filter) {
        facilitators = this.lodash.filter(
          facilitators,
          function (e) {
            return e.value
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return facilitators;
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.facilitator = {};
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/conduct/save_conduct_facilitator.gql"),
        variables: {
          conductFacilitatorId: "",
          parentId: "",
          value: this.facilitator.value,
          category: this.facilitatorType,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });
      this.close();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let name = this.facilitator.value;
      if (this.lodash.isEmpty(name?.trim())) {
        this.errors.facilitator = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
